import http from "./client";
import { ICertificate, ICertRequest } from "../entryes/panel/certificates/types";



interface IListQueryParams {
    course_id: number;
}

interface IListResponse {
    certificates: Array<ICertificate>
}


interface ICertificateResponse {
    certificate: ICertificate
}

async function list(queryParams: IListQueryParams): Promise<Array<ICertificate>> {
    const response = await http.get<IListResponse>('/api/certificates', {
        params: queryParams
    });
    return response.data.certificates;
}



async function save(certificate: ICertRequest): Promise<ICertificate> {
    const response = await http.post<ICertificate>('/api/certificates/save', certificate, {
        params: { course_id: certificate.course_id }
    });
    return response.data
}

async function getCert(id: number, courseId: number): Promise<ICertificate> {
    const response = await http.get<ICertificate>('/api/certificates/get', {
        params: { id, course_id: courseId }
    })
    return response.data;
}

async function check(number: string): Promise<Object> {
    const response = await http.get('/api/certificates/check', {
        params: { number }
    })
    return response.data;
}

async function testPdf(file: string | number): Promise<boolean> {
    const response = await http.get('/api/certificates/test-pdf', {
        params: { file}
    })
    return response.data.check;
}

async function remove(id: number): Promise<void> {
    await http.post<ICertificateResponse>('/api/certificates/delete', {
        id
    })
}

export const certificates = {
    getCert,
    check,
    testPdf,
    list,
    save,
    remove
}
